import { ReactNode } from "react";
import {
  RadioGroup as RARadioGroup,
  RadioGroupProps,
} from "react-aria-components";
import type { ErrorMessageType } from "../FieldError";
import { FieldError } from "../FieldError";
import { FormLabel } from "../FormLabel";
import styles from "./RadioButtonGroup.module.css";

interface IRadioButtonGroup extends Omit<RadioGroupProps, "children"> {
  autoFocus?: boolean;
  children: ReactNode;
  label: string;
  hideLabel?: boolean;
  description?: string;
  errorMessage?: ErrorMessageType;
}

const RadioButtonGroup = ({
  autoFocus,
  label,
  hideLabel = false,
  children,
  description,
  errorMessage,
  isDisabled,
  ...props
}: IRadioButtonGroup) => (
  <RARadioGroup isDisabled={isDisabled} {...props}>
    {!hideLabel && (
      <FormLabel
        label={label}
        description={description}
        isDisabled={isDisabled}
        autoFocus={autoFocus}
      />
    )}
    <div className={styles.radioGroupContainer}>{children}</div>
    <FieldError errorMessage={errorMessage} />
  </RARadioGroup>
);

export default RadioButtonGroup;
